module.exports = __webpack_public_path__ + "img/estado_documento.00c02a65.png";